import { Component, Inject, OnInit, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-confirm-share-screen',
  templateUrl: './confirm-share-screen.component.html',
  styleUrls: ['./confirm-share-screen.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatIcon,
    MatProgressBar,
    MatDivider,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class ConfirmShareScreenComponent implements OnInit {
  sendingInProgress = signal<boolean>(false);
  constructor(
    public dialogRef: MatDialogRef<ConfirmShareScreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  acceptSharingScreen() {
    this.sendingInProgress.set(true);

    setTimeout(() => {
      this.sendingInProgress.set(false);
      this.dialogRef.close('ACCEPT');
    }, 1000);
  }

  cancelSharingScreen() {
    this.dialogRef.close('CANCEL');
  }
}
